const ACTION_TYPES = require('constants/actionTypes/beautyPreferences');

const initialState = {
    beautyPreferences: {
        skinTone: '',
        skinConcerns: [],
        ageRange: '',
        skinType: '',
        hairConcerns: [],
        hairDescrible: [],
        hairColor: '',
        eyeColor: '',
        fragrancePreferences: [],
        shoppingPreferences: [],
        ingredientPreferences: []
        // favoriteBrands: [],
        // colorIQ: []
    },
    expandedPreference: 'skinType',
    profileCompletionPercentage: 0
};

const setColorIQ = (state, action) => {
    const currentCat = [];
    currentCat.push(action.payload.colorIQ);

    return {
        ...state,
        beautyPreferences: {
            ...state.beautyPreferences,
            colorIQ: currentCat
        }
    };
};

const setInitialBeautyPreferences = (state, action) => {
    return {
        ...state,
        beautyPreferences: {
            ...state.beautyPreferences,
            ...action.initialData
        },
        profileCompletionPercentage: action.profileCompletionPercentage
    };
};

const setMultiplePreferences = (state, action) => {
    return {
        ...state,
        beautyPreferences: {
            ...state.beautyPreferences,
            [action.category]: action.selectedProfiles
        }
    };
};

const clearPreference = (state, action) => {
    return {
        ...state,
        beautyPreferences: {
            ...state.beautyPreferences,
            [action.category]: []
        }
    };
};

const setExpandedPreference = (state, action) => {
    return {
        ...state,
        expandedPreference: action.expandedPreference
    };
};

const setProfileCompletionPercentage = (state, action) => {
    return {
        ...state,
        profileCompletionPercentage: action.profileCompletionPercentage
    };
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_INITIAL_BEAUTY_PREFERENCES:
            return setInitialBeautyPreferences(state, action);
        case ACTION_TYPES.SET_MULTIPLE_BEAUTY_PREFERENCES:
            return setMultiplePreferences(state, action);
        case ACTION_TYPES.CLEAR_BEAUTY_PREFERENCE:
            return clearPreference(state, action);
        case ACTION_TYPES.SET_COLOR_IQ:
            return setColorIQ(state, action);
        case ACTION_TYPES.SET_EXPANDED_PREFERENCE:
            return setExpandedPreference(state, action);
        case ACTION_TYPES.SET_PROFILE_COMPLETION_PERCENTAGE:
            return setProfileCompletionPercentage(state, action);
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
